import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import { LuminousGallery } from 'luminous-lightbox';

export default class extends Controller {

  connect() {
    const admin_gallery = document.querySelectorAll(".admin_image_gallery");
    const user_gallery = document.querySelectorAll(".user_image_gallery");
    if (admin_gallery != undefined){new LuminousGallery(admin_gallery);}
    if (user_gallery != undefined){new LuminousGallery(user_gallery);}
  }
}
